export default {
  id: null,
  name: null,
  title: null,
  email: null,
  company: null,
  cell_phone: null,
  is_reachable: null,
  country_code: "EMPTY",
};
